module.exports = __webpack_public_path__ + "images/d9ba019644a09a0538e3d2f877adaa03.svg";